module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\nBefore continue and in order to better assist you...")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.questions != null && _vm.values != null && _vm.errorMessages != null) ? _c('div', [(_vm.questions != null && _vm.values != null && _vm.errorMessages != null) ? _c('why-form', {
    ref: "userForm",
    attrs: {
      "questions": _vm.questions,
      "values": _vm.values,
      "error-messages": _vm.errorMessages
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickValidate()
      }
    }
  }, [_vm._v("Confirm")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/question.svg",
      "width": "100%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08169381","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutPaymentWhy.vue
// module id = 725
// module chunks = 3